<template>
    <div class="modal-wrap">
        <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap pr10">
            <el-form-item label="素材名称：" prop="material_name" v-if="isEdit">
                <el-input v-model.trim="formItem.material_name" :maxlength="300" placeholder="请输入素材名称" @input="changeMaterialName" style="width:300px;"></el-input>
            </el-form-item>

            <el-form-item label="项目类型：" prop="project_type">
                <el-radio-group v-model="formItem.project_type" :disabled="isEdit||isOrderUpload||isReUpload">
                    <el-radio label="1">通用
                        <el-tooltip class="item" effect="dark" content="任何项目都可以使用" placement="top">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </el-radio>
                    <el-radio label="2">指定项目</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="" prop="project_id" v-if="formItem.project_type=='2'">
                <ESelect
                    v-model="formItem.project_id"
                    clearable
                    filterable
                    remote
                    reserve-keyword
                    :disabled="isEdit||isOrderUpload||isReUpload"
                    :remote-method="remoteProjectMethod"
                    :loading="remoteProjectLoading"
                    @change="changeProject"
                    style="width: 500px;"
                    no-match-text="请前往 “信息管理-客户产品管理 ”中录入产品"
                    no-data-text="请前往 “信息管理-客户产品管理 ”中录入产品"
                    placeholder="请输入项目名称关键字搜索">
                    <el-option
                        v-for="item in projectList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </ESelect>
            </el-form-item>
            <el-form-item prop="material_type" label="素材类型：">
                <el-radio-group v-model="formItem.material_type" :disabled="uploadFiles.length>0||isOrderUpload||isEdit||isReUpload" @change="changeMaterialType">
                    <el-radio label="1">图片</el-radio>
                    <el-radio label="2">视频</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="产品类型：" prop="app_type">
                <el-radio-group v-model="formItem.app_type" @change="changeAppType" :disabled="isOrderUpload||isOrderMaterialEdit||isReUpload">
                    <el-radio label="1">应用</el-radio>
                    <el-radio label="2">游戏</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="" prop="package_type">
                <el-radio-group v-model="formItem.package_type" @change="changeAppType" :disabled="packageTypeDisabled">
                    <el-radio label="11">安卓应用</el-radio>
                    <el-radio label="12">安卓快应用</el-radio>
                    <el-radio label="3">小程序</el-radio>
                    <el-radio label="21">iOS应用</el-radio>
                    <el-radio label="41">鸿蒙应用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="" prop="game_classify" v-if="formItem.app_type=='2'">
                <el-radio-group v-model="formItem.game_classify" @change="changeGameClassify" :disabled="isOrderUpload||isOrderMaterialEdit||isReUpload">
                    <el-radio label="3">IAA</el-radio>
                    <el-radio label="4">IAP</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="标签设置：" prop="label_type" class="label-required">
                <el-radio-group v-model="formItem.label_type" :disabled="isEdit||isReUpload" @change="changeLabelType">
                    <el-radio label="1">分别设置素材标签</el-radio>
                    <el-radio label="2">统一设置素材标签</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="素材标签：" prop="label_ids" v-if="formItem.label_type=='2'" class="label-required">
                <JtLabelCascader
                    placement="bottom-start"
                    size="mini"
                    class="mr20 full-w"
                    v-model="labelIds"
                    :options="labelList"
                    :props="{value:'id',label:'name',emitPath:false,expandTrigger: 'hover',multiple:true,}"
                    :show-all-levels="false"
                    @change="changeLabelIds"
                    @remove-delete-tag="removeDeleteTag"
                    :deleteLabels="deleteLabels"
                    clearable
                    filterable
                    style="width: 500px;"
                    placeholder="请选择">
                </JtLabelCascader>
            </el-form-item>
            <el-form-item prop="file_labels">
                <div class="pre-file-wrap">
                    <div v-for="(file,index) in uploadFiles" class="relative mb10 file-item" :key="index">
                        <template v-if="file.isPreChecked">
                            <!--单独标签设置-->
                            <div v-if="formItem.label_type=='1'" class="mb10">
                                <JtLabelCascader
                                    :ref="'singleJtLabelCascader'+file.md5"
                                    placement="bottom-start"
                                    size="mini"
                                    class="mr20 full-w select-tags-width"
                                    v-model="file.label_ids"
                                    :options="labelList"
                                    :props="{value:'id',label:'name',emitPath:false,expandTrigger: 'hover',multiple:true,}"
                                    :show-all-levels="false"
                                    @remove-delete-tag="(tag)=>removeFileDeleteTag(file,tag)"
                                    :deleteLabels="file.delete_labels"
                                    collapse-tags
                                    clearable
                                    filterable
                                    placeholder="请选择标签">
                                </JtLabelCascader>
                            </div>
                            <div class="file-preview" v-if="isEdit">
                                <el-popover trigger="hover" :width="450" @show="startVideoPlay(file)" @hide="stopVideoPlay(file)" :disabled="preCheckLoading">
                                    <div slot="reference">
                                        <img v-if="file.material_type=='1'" :src="file.material_url">
                                        <video v-else-if="file.material_type=='2'" :src="file.material_url" type="video/mp4"></video>
                                    </div>
                                    <div class="material-large-poptip">
                                        <img v-if="file.material_type=='1'" :src="file.material_url" alt="">
                                        <video v-else-if="file.material_type=='2'" :src="file.material_url" :data-md5="file.md5" controls="" type="video/mp4" controlslist="nodownload"></video>
                                    </div>
                                </el-popover>
                            </div>
                            <div class="file-preview" v-else>
                                <template v-if="file.fileData.type.includes('image')||file.fileData.type.includes('video')">
                                    <el-popover trigger="hover" :width="450" @show="startVideoPlay(file)" @hide="stopVideoPlay(file)" :disabled="preCheckLoading">
                                        <div slot="reference">
                                            <img v-if="file.fileData.type.includes('image')" :src="getFilePath(file.fileData)" :alt="file.fileData.name">
                                            <img v-else-if="file.fileData.type.includes('video')&&file.fileData.v_url" :src="file.fileData.v_url">
                                            <video preload="none" v-else-if="file.fileData.type.includes('video')" :src="getFilePath(file.fileData)" type="video/mp4"></video>
                                        </div>
                                        <div class="material-large-poptip">
                                            <img v-if="file.fileData.type.includes('image')" :src="getFilePath(file.fileData)" alt="">
                                            <video preload="none" v-else-if="file.fileData.type.includes('video')" :src="getFilePath(file.fileData)" :data-md5="file.md5" controls="" type="video/mp4" controlslist="nodownload"></video>
                                        </div>
                                    </el-popover>
                                </template>
                                <p v-else>文件格式有误，展示失败</p>
                                <span class="remove-icon el-icon-circle-close" @click="handleRemoveFile(index)"></span>
                            </div>
                            <div class="file-info-text" v-if="isEdit">
                                <span>{{file.width}}*{{file.height}}</span>
                                <span>{{file.material_size+file.material_size_unit}}</span>
                                <span v-if="file.material_type=='2'||(file.material_duration&&file.material_duration!='-')">{{getMaterialDurationText(file.material_duration)}}</span>
                            </div>
                            <div class="file-info-text" v-else>
                                <span>{{file.fileData.width}}*{{file.fileData.height}}</span>
                                <span>{{formatFileSize(file.fileData.size)}}</span>
                                <span v-if="file.material_duration&&file.material_duration!='-'">{{getMaterialDurationText(file.material_duration)}}</span>
                            </div>
                            <p :title="file.fileData.name" class="tac ellipsis text-color-normal font12px" v-if="!isEdit">{{file.fileData.name||'--'}}</p>
                            <el-input size="mini" :maxlength="100" show-word-limit v-model="file.material_label" placeholder="名称未解析到标签"/>
                        </template>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="上传素材：" prop="files" class="label-required" v-if="!(isEdit||(isReUpload&&uploadFiles.length>=1))">
                <div class="upload-box">
                    <el-upload
                        ref="upload"
                        class="upload-btn"
                        drag
                        :http-request="fileRequest"
                        :before-upload="handleUpload"
                        :on-change="handleFileChange"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-progress="handleProgress"
                        :before-remove="beforeRemove"
                        :show-file-list="false"
                        action="#"
                        multiple>
                        <div :class="[isOrderUpload?'is-order-upload':'is-store-upload',isReUpload?'is-re-upload':'',isEdit?'is-edit':'']">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                                <template v-if="isOrderUpload||isReUpload">
                                    <div>上传文件</div>
                                    <div class="pb20">
                                        <p v-for="(item,index) in taskList" :key="index">
                                            <span class="">{{orderInfo.material_type_text}}；</span>
                                            <span class="">{{item.width}}*{{item.height}}；</span>
                                            <span class=""><span class="less-than">⩽</span>{{item.material_size}}{{item.material_size_unit}}；</span>
                                            <span class="">{{item.material_format}}；</span>
                                            <span class="" v-if="item.material_duration"><span class="less-than">⩽</span>{{item.material_duration}}s；</span>
                                            <!--<span class="">{{item.material_num}}；</span>-->
                                            <span class="">{{(isReUpload?1:item.allow_upload_num) - uploadedNum[item.width+'*'+item.height]||0}}；</span>
                                        </p>
                                    </div>
                                </template>
                                <div class="mt200" v-else>上传文件</div>
                            </div>
                            <div class="upload-loading-wrap" v-if="preCheckLoading||uploadingFileCnt>0" title="素材正在处理中..."><i class="el-icon-loading"></i></div>
                        </div>
                    </el-upload>
                </div>
            </el-form-item>

            <template v-if="isOrderUpload||isOrderMaterialEdit">
                <el-form-item prop="distribution_method" label="分配方式：" class="label-required">
                    <div class="mt8 mb20" v-for="item in batchProducer">
                        <p class="font12px">任务ID：{{item.detail_id}} 素材尺寸：{{item.width+'*'+item.height}}</p>
                        <template v-if="(item.detail||[]).length>1">
                            <el-radio-group v-model="item.distribution_method" @change="(val)=>changeBatchProducerDistributionMethod(val,item)">
                                <el-radio label="1">平均分配</el-radio>
                                <el-radio label="2">自定义分配比例</el-radio>
                            </el-radio-group>

                            <div v-if="item.distribution_method=='2'" class="mt10">
                                <p v-for="inner in item.detail" :key="inner.uid" class="mb6 font12px">
                                    <span class="user-name-label">{{inner.name}}：</span>
                                    <el-input-number v-model="inner.ratio" :max="100" @change="clearValidate('distribution_method')" label="分配比例" size="mini" :controls="false"></el-input-number> %
                                </p>
                            </div>
                        </template>
                        <div v-else class="mt10">
                            <p v-for="inner in item.detail" :key="inner.uid" class="mb6 font12px">
                                <span class="user-name-label">{{inner.name}}：</span> 100%
                            </p>
                        </div>
                    </div>

                </el-form-item>
            </template>
            <template v-else>
                <el-form-item prop="producer_type" label="制作人数：">
                    <el-radio-group v-model="formItem.producer_type" @change="changeProducerType">
                        <el-radio label="1">单人</el-radio>
                        <el-radio label="2">多人</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="distribution_method" label="分配方式：" v-if="formItem.producer_type=='2'" class="label-required">
                    <el-radio-group v-model="formItem.distribution_method" @change="changeDistributionMethod">
                        <el-radio label="1">平均分配</el-radio>
                        <el-radio label="2">自定义分配比例</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="producer" label="选择制作人：" class="label-required">
                    <!--单人制作-->
                    <template v-if="formItem.producer_type=='1'">
                       <!-- <el-select v-model="singleProducer" filterable clearable placeholder="请选择制作人">
                            <el-option
                                v-for="item in producerList"
                                :key="item.id"
                                :label="item.name+'('+item.mobile+')'"
                                :disabled="item.disabled"
                                :value="item.id">
                            </el-option>
                        </el-select>-->
                        <el-cascader
                            v-model="singleProducer"
                            :options="producerGroupList"
                            filterable clearable
                            :props="{emitPath:false,value:'id',label:'name'}"
                            placeholder="请选择制作人">
                        </el-cascader>
                    </template>

                    <!--多人制作：平均分配-->
                    <template v-else-if="formItem.producer_type==2&&formItem.distribution_method=='1'">
                        <div style="width: 500px;">
                            <p class="mb10">
                                <!--<el-select v-model="distributionProducer" multiple filterable clearable style="width: 500px;" placeholder="选择制作人">
                                    <el-option
                                        v-for="item in producerList"
                                        :key="item.id"
                                        :label="item.name+'('+item.mobile+')'"
                                        :disabled="item.disabled"
                                        :value="item.id">
                                    </el-option>
                                </el-select>-->
                                <el-cascader
                                    v-model="distributionProducer"
                                    :options="producerGroupList"
                                    filterable
                                    clearable
                                    :props="{multiple: true,emitPath:false,value:'id',label:'name'}"
                                    placeholder="请选择制作人"
                                    style="width: 500px;">
                                </el-cascader>
                            </p>
                        </div>
                    </template>

                    <!--多人制作：自定义比例分配-->
                    <template v-else-if="formItem.producer_type==2&&formItem.distribution_method=='2'">
                        <div style="width: 500px;">
                            <p class="mb10" v-for="item in producerRatioList">
                                <!--<el-select v-model="item.id" filterable clearable @change="changeProducerList" placeholder="选择制作人"  style="width: 200px;">
                                    <el-option v-for="inner in producerList" :value="inner.id" :label="inner.name+'('+inner.mobile+')'" :key="inner.id" :disabled="inner.disabled"></el-option>
                                </el-select>-->
                                <el-cascader
                                    v-model="item.id"
                                    :options="producerGroupList"
                                    filterable
                                    clearable
                                    :props="{emitPath:false,value:'id',label:'name'}"
                                    @change="changeProducerList"
                                    placeholder="请选择制作人"
                                    style="width: 200px;">
                                </el-cascader>
                                <el-input v-model.trim="item.ratio" placeholder="输入自定义比值" @input="clearValidate('producer')" class="ml10" style="width: 120px" /> %
                                <el-button type="primary" size="mini" @click="removeProducerRatio(item.id)" class="ml20" :disabled="producerRatioList.length<=1">删除</el-button>
                            </p>
                            <el-button type="primary" size="small" @click="addProducerRatio">+ 添加</el-button>
                        </div>
                    </template>

                </el-form-item>
            </template>
        </el-form>
        <div class="dialog-footer pt20 tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" :disabled="preCheckLoading||uploadingFileCnt>0" class="action-btn ml20">{{isEdit?'保存':'上传'}}</el-button>
        </div>
    </div>
</template>


<script>
    import getMediaInfo from '@/libs/media.js';
    import utils from '@/libs/utils.js';
    import API from '@/api/workOrder/upload.js';
    import { cloneDeep,uniq,debounce } from 'lodash';
    import { validEmoji,validHtml } from '@/utils/validate';
    import {JtLabelCascader } from '@/components/Ele';
    import matomoFun from "@/utils/matomo.js";
    import md5 from 'js-md5';
    export default {
        name: "UploadMaterialModal",
        components:{
            JtLabelCascader,
        },
        props:{
            cbs:{
                type:Object,
            },
            behaviorCategory:String,
            name:String,
            typeText:String,
            taskList:Array,         // 任务明细列表，工单上传时用
            orderInfo:Object,      // 工单信息，工单上传时用
            isBatch:Boolean,    // 是否是批量上传
            isEdit:Boolean,     // 是否是编辑素材
            isReUpload:Boolean,
            materialInfo:Object,
        },
        data(){
            let _this = this;
            const validateMaterialName = (rule, value, callback) => {
                if(_this.isEdit){
                    const regex = /[<>\/?{}"|\\';#¥%^&*+=]/;
                    if(validEmoji(value)){
                        callback(new Error('素材名称不能有表情'));
                    }else if(value.includes(' ')){
                        callback(new Error('素材名称不能有空格'));
                    }else if(validHtml(value)){
                        callback(new Error('素材名称不能有html标签'));
                    }else if(regex.test(value)){
                        callback(new Error('不能有特殊字符（<>?/{}”\\|‘;#¥%^&*+=）'));
                    }else{
                        callback();
                    }
                }else{
                    callback();
                }
            };
            const validateProject = (rule, value, callback) => {
                if(_this.formItem.project_type=='1'){
                    callback();
                }else{
                    if(!_this.formItem.project_id){
                        callback(new Error('请选择项目名称'));
                    }else{
                        callback();
                    }
                }
            };
            const validateGameClassify = (rule, value, callback) => {
                if(_this.formItem.app_type=='1'){
                    callback();
                }else{
                    if(!value){
                        callback(new Error('请选择游戏分类'));
                    }else{
                        callback();
                    }
                }
            };
            const validateLabel = (rule, value, callback) => {
                /*label_type:1-单独设置，2-统一设置*/
                if(_this.formItem.label_type=='2'){
                    if(_this.labelIds.length<=0&&_this.deleteLabels.length<=0){
                        callback(new Error('请设置素材标签'));
                    }else{
                        callback();
                    }
                }else{
                    callback();
                }
            };
            const validateFiles = (rule, value, callback) => {
                if(_this.uploadFiles.length>0){
                    callback();
                }else{
                    callback(new Error('请上传素材文件'));
                }
            };
            const validateFileLabels = (rule, value, callback) => {
                if(_this.uploadFiles.some(item=>{
                    if (!item.material_label) {
                        return false;
                    }else if(item.material_label.length>100) {
                        return true
                    }else {
                        return false;
                    }
                })) {
                    callback(new Error('素材标签最多输入100个字符'));
                }else if(_this.formItem.label_type=='2'){
                    callback();
                }else if(_this.uploadFiles.some(item=>(item.label_ids||[]).length<=0&&(item.delete_labels||[]).length<=0)){
                    callback(new Error('每个素材都需要单独设置标签，请检查'));
                }else{
                    callback();
                }
            };
            const validateDistributionMethod = (rule, value, callback) => {
                if(_this.isOrderUpload||_this.isOrderMaterialEdit){
                    let errList = [];
                    _this.batchProducer.forEach(item=>{
                        if(item.distribution_method=='2'){
                            let detail = item.detail||[];
                            let total = 0;
                            detail.forEach(inner=>{
                                total = total + inner.ratio;
                            })
                            if(total!=100){
                                errList.push(item);
                            }
                        }
                    })
                    if(errList.length>0){
                        callback(new Error('制作人分配比例有误，请检查'));
                    }else{
                        callback();
                    }
                }else{
                    if(_this.formItem.producer_type=='1'){
                        callback();
                    }else{
                        if(!_this.formItem.distribution_method){
                            callback(new Error('请选择分配方式'));
                        }else{
                            callback();
                        }
                    }
                }
            };
            const validateProducer = (rule, value, callback) => {
                if(_this.formItem.producer_type=='1'){
                    // 单人制作
                    if(!this.singleProducer){
                        callback(new Error('请选择制作人'));
                    }else{
                        callback();
                    }
                }else{
                    // 多人制作
                    if(_this.formItem.distribution_method=='1'){
                        // 平均分配
                        if(this.distributionProducer.length<=0){
                            callback(new Error('请选择制作人'));
                        }else{
                            callback();
                        }
                    }else{
                        // 自定义比例
                        let selectProduces = this.producerRatioList.filter(item=>item.id);
                        let ratios = this.producerRatioList.map(item=>+item.ratio);
                        if(selectProduces.length<=1){
                            callback(new Error('制作人最少选择2人'));
                        }else if(selectProduces.some(item=>!item.ratio)){
                            callback(new Error('自定义比例设置不能为空'));
                        }else if(ratios.includes(NaN)){
                            callback(new Error('自定义比例必须设置成数字'));
                        }else if(ratios.some(item=>item<0)){
                            callback(new Error('自定义比例不能是负数'));
                        }else if(ratios.some(item=>item>100)){
                            callback(new Error('自定义比例不能大于100'));
                        }else if(ratios.some(item=>((item+'').split('.').reverse()[0].length)>2&&(item+'').includes('.'))){
                            callback(new Error('自定义比例只支持两位小数'));
                        }else if(utils.getArraySum(ratios)<=99.99||utils.getArraySum(ratios)>=100.01){
                            callback(new Error('自定义比例相加需为100%'));
                        }else{
                            callback();
                        }
                    }
                }
            };


            return {
                formItem:{
                    material_name:'',
                    project_type:'1',
                    project_id:'',
                    project_name:'',
                    material_type:'1',
                    app_type:'',
                    package_type:'',
                    game_classify:'',
                    label_type:'2',
                    producer_type:'1',
                    distribution_method:'1',
                },
                rules:{
                    material_name:[
                        { validator: validateMaterialName, trigger: 'blur' },
                    ],
                    project_type:[
                        { required: true, message: '请选择项目类型', trigger: 'blur' },
                    ],
                    project_id:[
                        { validator: validateProject, trigger: 'blur' },
                    ],
                    material_type:[
                        { required: true, message: '请选择素材类型', trigger: 'blur' },
                    ],
                    app_type:[
                        { required: true, message: '请选择产品类型', trigger: 'blur' },
                    ],
                    package_type:[
                        { required: true, message: '请选择包体类型', trigger: 'blur' },
                    ],
                    game_classify:[
                        { validator: validateGameClassify, trigger: 'blur' },
                    ],
                    label_type:[
                        { required: true, message: '请选择标签设置方式', trigger: 'blur' },
                    ],
                    label_ids:[
                        { validator: validateLabel, trigger: 'blur' },
                    ],
                    files:[
                        { validator: validateFiles, trigger: 'blur' },
                    ],
                    file_labels:[
                        { validator: validateFileLabels, trigger: 'blur' },
                    ],
                    producer_type:[
                        { required: true, message: '请选择制作人数', trigger: 'blur' },
                    ],
                    distribution_method:[
                        { validator: validateDistributionMethod, trigger: 'custom' },
                    ],
                    producer:[
                        { validator: validateProducer, trigger: 'custom' },
                    ],
                },
                projectList:[],
                deleteLabels:[],
                labelList:[],
                labelIds:[],    // 统一设置的素材标签
                uploadFiles:[],     // 上传的所有文件
                singleProducer:'',      // 单独制作人
                distributionProducer:[],        // 多人制作-平均分配
                producerRatioList:[
                    {
                        id:'',
                        ratio:''
                    }
                ],   // 多人制作-分配比例
                producerList:[],        // 制作人列表
                producerGroupList:[],        // 仅素材库上传-显示部门
                remoteProjectLoading:false,
                batchProducer:{},       // 仅批量时需要
                submitLoading:false,
                formatImage:[],
                formatVideo:[],
                preCheckLoading:false,
                uploadingFileCnt:0,
                isPackageTypeNull:false,
            }
        },
        computed:{
            formatImageExt(){
                return (this.formatImage||[]).map(item=>'.'+item);
            },
            formatVideoExt(){
                return (this.formatVideo||[]).map(item=>'.'+item);
            },
            isOrderUpload(){
                let orderInfo = this.orderInfo||{};
                return !!orderInfo.order_name;
            },
            uploadedNum(){
                let uploadData = {};
                let taskList = this.taskList||[];
                taskList.forEach(item=>{
                    let size = item.width+'*'+item.height;
                    let count = this.uploadFiles.filter(inner=>inner.width+'*'+inner.height==size).length;
                    uploadData[size] = count;
                });
                return uploadData;
            },
            isOrderMaterialEdit(){
                if(!this.isEdit) return false;
                let materialData = this.materialInfo||{};
                return materialData.source=='1'||materialData.source=='工单';        // 1-工单  2-素材库
            },
            isStoreMaterialEdit(){
                if(!this.isEdit) return false;
                let materialData = this.materialInfo||{};
                return materialData.source=='2'||materialData.source=='素材库';          // 1-工单  2-素材库
            },
            orderId(){
                let orderInfo = this.orderInfo||{};
                return orderInfo.order_id||orderInfo.id||'';
            },
            packageTypeDisabled(){
                if((this.isOrderUpload||this.isOrderMaterialEdit||this.isReUpload)){
                    if(this.isPackageTypeNull){
                        return false;
                    }else{
                        return !!this.formItem.package_type;
                    }
                }else{
                    return false
                }
            }
        },
        watch:{
            producerRatioList(){
                this.changeProducerList();
            }
        },
        mounted(){
            Promise.all([
                this.getMaterialFormat('1'),
                this.getMaterialFormat('2'),
            ]);
            if(this.isOrderUpload){
                this.setOrderInfo();
                this.setBatchProducer();
            }
            if(this.isReUpload){
                // 重新上传 重置数据
                this.setReUploadMaterialInfo();
            }
            if(this.isEdit){
                this.setMaterialInfo();
            }

            this.getLabelList();
            if(!this.isOrderUpload&&!this.isOrderMaterialEdit){
                this.getProducerGroupList();
            }
            this.preCheckLoading = false;
        },
        methods:{
            handleClose() {
                this.submitLoading = false;
                this.$emit('close');
            },
            getMaterialFormat(val){
                return API.getMaterialFormat({
                    type:val,
                }).then(res=>{
                    console.log('getMaterialFormat',res);
                    let resData = res.data||[];
                    if(val=='1'){
                        this.formatImage = resData;
                    }else{
                        this.formatVideo = resData;
                    }
                },err=>{
                    console.log('getMaterialFormat err',err);
                })
            },
            setReUploadMaterialInfo(){
                let materialInfo = this.materialInfo||{};
                let projectId = materialInfo.project_id=='0'?'':materialInfo.project_id;

                if(materialInfo.source=='1'){
                    // 来源工单，指定项目2
                    this.formItem.project_type = '2';
                    this.formItem.project_id = projectId;
                    this.formItem.project_name = materialInfo.project_name;
                    this.projectList = [{
                        label:materialInfo.project_name,
                        value:projectId,
                    }];
                    this.formItem.app_type = materialInfo.app_type;
                    this.formItem.package_type = materialInfo.package_type;
                    this.isPackageTypeNull = materialInfo.package_type=='0';
                    if(materialInfo.app_type=='2'){
                        this.formItem.game_classify = materialInfo.game_classify;
                    }
                }else{
                    this.formItem.project_type = '1';
                }
                this.formItem.material_type = materialInfo.material_type||materialInfo.type;
                this.formItem.label_type = '2';
                // workOrder_v5 需求一：label_list 里 id='-1' 是后端按素材分类标签归类出的伪标签（可多条），不是真实素材标签，回填时剔除
                this.labelIds = (materialInfo.label_list||[]).filter(item=>item.id!=='-1').map(item=>item.id);
                this.deleteLabels = materialInfo.delete_labels||[];
                let producerList = materialInfo.producer_list||[];
                this.formItem.producer_type = producerList.length===1?'1':'2';
                let firstRatio = producerList[0].ratio||'';
                this.formItem.distribution_method = firstRatio&&producerList.every(item=>item.ratio===firstRatio)?'1':'2';

                if(producerList.length===1){
                    this.singleProducer = producerList[0].uid;
                }else if(this.formItem.distribution_method=='1'){
                    this.distributionProducer = producerList.map(item=>item.uid);
                }else if(this.formItem.distribution_method=='2'){
                    this.producerRatioList = producerList.map(item=>{
                        return {
                            id:item.uid,
                            ratio:item.ratio,
                        }
                    });
                }
            },
            setMaterialInfo(){
                let materialInfo = this.materialInfo||{};
                let projectId = materialInfo.project_id=='0'?'':materialInfo.project_id;
                console.log('setMaterialInfo',materialInfo);
                this.formItem.material_name = materialInfo.material_name||'';
                if(materialInfo.source=='1'){
                    // 来源工单，指定项目2
                    // this.formItem.project_type = '2';
                }else{
                    // this.formItem.project_type = '1';
                }
                this.formItem.project_type = projectId&&materialInfo.project_name?'2':'1';
                this.formItem.project_id = projectId;
                this.formItem.project_name = materialInfo.project_name;
                this.projectList = [{
                    label:materialInfo.project_name,
                    value:projectId,
                }];
                this.formItem.app_type = materialInfo.app_type;
                this.formItem.package_type = materialInfo.package_type;
                this.isPackageTypeNull = materialInfo.package_type=='0';
                if(materialInfo.app_type=='2'){
                    this.formItem.game_classify = materialInfo.game_classify;
                }
                this.formItem.material_type = materialInfo.material_type||materialInfo.type;
                this.formItem.label_type = '1';
                // workOrder_v5 需求一：剔除 id='-1' 伪标签（同上）
                const realLabelIds = (materialInfo.label_list||[]).filter(item=>item.id!=='-1').map(item=>item.id);
                this.labelIds = realLabelIds;
                this.deleteLabels = materialInfo.delete_labels||[];
                this.uploadFiles = [{
                    label_ids:[...realLabelIds],
                    delete_labels:materialInfo.delete_labels||[],
                    fileData:'',
                    material_type:materialInfo.material_type,
                    material_url:materialInfo.material_url,
                    md5:materialInfo.material_md5,
                    assign_id:'',
                    width:materialInfo.width,
                    height:materialInfo.height,
                    material_size:materialInfo.material_size,
                    material_size_unit:materialInfo.material_size_unit,
                    material_format:materialInfo.material_format,
                    material_duration:materialInfo.material_duration,
                    material_label:materialInfo.material_label,
                    isPreChecked:true,
                }];

                let producerList = cloneDeep(materialInfo.producer_list||[]).map(item=>{
                    let ratio = item.ratio||0;
                    if(ratio>0&&ratio<1){
                        ratio = ratio*100;
                        if((ratio+'').includes('.')){
                            ratio = ratio.toFixed(2);
                        }
                        item.ratio = +ratio;
                    }else if(ratio==1){
                        item.ratio = ratio*100;
                    }
                    return item;
                });
                let firstRatio = producerList[0]?.ratio||'';
                if(this.isOrderMaterialEdit){
                    /* 工单-素材编辑 */
                    let taskId = materialInfo.task_id;

                    this.batchProducer = [{
                        detail_id:taskId,
                        width:materialInfo.width,
                        height:materialInfo.height,
                        distribution_method: firstRatio&&producerList.every(item=>item.ratio===firstRatio)?'1':'2',
                        detail:producerList.map(item=>{
                            return {
                                id:item.uid,
                                ratio:item.ratio,
                                name:item.name,
                            }
                        }),
                    }];

                }else{
                    /* 素材库-素材编辑 */
                    this.formItem.producer_type = producerList.length===1?'1':'2';
                    this.formItem.distribution_method = firstRatio&&producerList.every(item=>item.ratio===firstRatio)?'1':'2';

                    if(producerList.length===1){
                        this.singleProducer = producerList[0].uid;
                    }else if(this.formItem.distribution_method=='1'){
                        this.distributionProducer = producerList.map(item=>item.uid);
                    }else if(this.formItem.distribution_method=='2'){
                        this.producerRatioList = producerList.map(item=>{
                            return {
                                id:item.uid,
                                ratio:item.ratio,
                                name:item.name,
                            }
                        });
                    }
                }
            },
            setOrderInfo(){
                let orderInfo = this.orderInfo||{};
                this.formItem.project_type = '2';
                this.formItem.project_id = orderInfo.project_id;
                this.formItem.project_name = orderInfo.project_name;
                this.projectList = [{
                    label:orderInfo.project_name,
                    value:orderInfo.project_id,
                }];

                this.formItem.material_type = orderInfo.type||orderInfo.material_type;
                this.formItem.app_type = orderInfo.app_type;
                this.formItem.package_type = orderInfo.package_type;
                this.isPackageTypeNull = orderInfo.package_type=='0';
                if(orderInfo.app_type=='2'){
                    this.formItem.game_classify = orderInfo.game_classify;
                }

                if(this.taskList.length==1){
                    /*label_type:1-单独设置，2-统一设置*/
                    this.formItem.label_type = '2';
                    let labelList = this.taskList[0].label||[];
                    this.labelIds = labelList.map(item=>item.id);
                    this.deleteLabels = this.taskList[0].delete_labels ||[];
                }else if(this.taskList.length>1){
                    this.formItem.label_type = '1';
                }
            },
            setBatchProducer(){
                if(this.isReUpload){
                    let materialInfo = this.materialInfo||{};
                    let producer = (materialInfo.producer_list||[]).map(item=>{
                        return {
                            uid:item.uid,
                            ratio:item.ratio,
                            name:item.name,
                        }
                    });
                    this.batchProducer = [{
                        distribution_method:this.formItem.distribution_method,
                        detail:producer,
                        detail_id:materialInfo.task_id,
                        width:materialInfo.width,
                        height:materialInfo.height,
                    }];
                }else{
                    this.batchProducer = this.taskList.map(item=>{
                        let producer = item.producer.map(inner=>{
                            return {
                                uid:inner.uid,
                                ratio:inner.ratio,
                                name:inner.name,
                            }
                        });
                        return {
                            distribution_method:'1',
                            detail:producer,
                            detail_id:item.id,
                            width:item.width,
                            height:item.height,
                        }
                    });
                }

            },
            getLabelList(){
                API.getLabelList({
                    type:this.formItem.material_type,
                }).then(res=>{
                    console.log('getLabelList',res);
                    this.labelList = res.data||[];

                },err=>{
                    console.log('getLabelList err',err);
                    this.labelList = [];
                    this.$message.error(err.info||'请求异常');
                })
            },
            getProducerGroupList(){
                if(this.isReUpload) return;
                API.getProducerGroupList({
                    detail_assign_id:'',        // 指派ID（暂时不用）
                }).then(res=>{
                    console.log('getProducerGroupList',res);
                    this.producerGroupList = (res.data||[]).map(item=>{
                        item.children = (item.children||[]).map(inner=>{
                            // inner.disabled = inner.user_status=='0';
                            return inner;
                        });

                        return item;
                    });

                    /*if(this.isEdit){
                        let oldProducer = this.materialInfo.producer_list||this.materialInfo.producer||[];
                        if(oldProducer.length>0){
                            oldProducer.forEach(item=>{
                                if(!this.producerList.find(inner=>inner.id==item.uid)){
                                    this.producerList.push({
                                        id:item.uid,
                                        name:item.name,
                                        mobile:'-',
                                        isDeleted:true,
                                    })
                                }
                            })
                        }
                    }*/
                },err=>{
                    console.log('getProducerGroupList err',err);
                    this.producerList = [];
                    this.$message.error(err.info||'请求异常');
                })
            },
            remoteProjectMethod(query){
                if (query.length >0) {
                    this.remoteProjectLoading = true;

                    let apiType = 'getProjectList';
                    if(this.isStoreMaterialEdit||!this.orderId){
                        apiType = 'getStoreProjectList';
                    }
                    API[apiType]({
                        search:query,
                    }).then(res=>{
                        let resData = [];
                        if(apiType == 'getProjectList'){
                            resData = (res.data||{}).list||[];
                        }else{
                            resData = res.data||[];
                        }
                        this.projectList = resData.map(item=>{
                            return {
                                value:item.project_id,
                                label:item.project_name,
                            }
                        });
                        this.remoteProjectLoading = false;
                    },err=>{
                        console.log('getOrgSelectorList err',err);
                        this.projectList = [];
                        this.remoteProjectLoading = false;
                        if (err.code == '403') {
                            this.$confirm(err.info||'请求异常', '提示', {
                                confirmButtonText: '刷新',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                window.location.reload()
                            }).catch(() => {
                            });
                            return
                        }
                    })

                } else {
                    this.projectList = [];
                }
            },
            changeProject(val){
                if(!val){
                    this.formItem.project_name = '';
                }else{
                    let actionItem = this.projectList.find(item=>item.value==val);
                    this.formItem.project_name = actionItem.label||'';
                }
                this.$refs.form.validateField('project_id');
            },




            changeMaterialName(){
                this.$refs.form.validateField('material_name');
            },
            changeMaterialType(val){
                console.log('changeMaterialType',val);
                this.getLabelList();
                this.labelIds = [];
            },
            changeAppType(){
                this.$refs.form.validateField('app_type');
            },
            changeGameClassify(){
                this.$refs.form.validateField('game_classify');
            },
            changeLabelIds(){
                this.$refs.form.validateField('label_ids');
            },
            removeDeleteTag(tag){
                console.log(789,'removeDeleteTag',tag);
                let index = this.deleteLabels.findIndex(item=>item.id==tag.key);
                if(index!=-1){
                    this.deleteLabels.splice(index2,1);
                }
            },
            removeFileDeleteTag(file,tag){
                console.log('removeFileDeleteTag',file,tag);
            },

            changeProducerType(val){
                console.log('changeProducerType',val);
                // 切换制作人数
                if(val=='1'){
                    this.setSingleProducer();
                }else if(val == '2') {
                    this.distributionProducer = [];
                    this.producerRatioList = [
                        {
                            id:'',
                            ratio:''
                        }
                    ];
                }
                this.formItem.distribution_method ='1';
            },
            setSingleProducer(){
                this.singleProducer = this.producerList.length>0?this.producerList[0].id:'';
            },
            changeDistributionMethod(val){
                // 切换分配方式：平均分配 or 自定义比例
                if(val =='1'){
                    this.distributionProducer = [];
                }else if(val =='2'){
                    this.producerRatioList = [
                        {
                            id:'',
                            ratio:''
                        }
                    ];
                }
                this.changeProducerList();
                this.$refs.form.clearValidate('distribution_method');
            },
            changeProducerList(){
                this.producerGroupList.forEach(group=>{
                    let children = group.children||[];
                    children.forEach(inner=>{
                        // inner.disabled = inner.user_status=='0';
                    })
                });
                this.clearValidate('producer');
            },
            addProducerRatio(){
                console.log('addProducerRatio');
                this.producerRatioList.push({
                    id:'',
                    ratio:''
                });
            },
            removeProducerRatio(id){
                console.log('removeProducerRatio',id);
                this.producerRatioList.splice(this.producerRatioList.findIndex(item => item.id ===id),1);
            },
            changeBatchProducerDistributionMethod(val,item){
                console.log('changeBatchProducerDistributionMethod',val,item);
                if(val=='2'){
                    let detail = item.detail||[];
                    detail.forEach(inner=>{
                        inner.ratio = undefined;
                    })
                }
                this.$refs.form.clearValidate('distribution_method');
            },

            handleSubmit() {
                this.$refs.form.validate((valid) => {
                    if(valid){
                        if(this.behaviorCategory && this.name){
                            matomoFun.trackEvent(this.behaviorCategory, '点击', this.name);
                        }
                        let stopTags = [];
                        if(this.isEdit){
                            let delete_labels = this.materialInfo.delete_labels||[];
                            delete_labels.forEach(item=>{
                                if(!stopTags.find(inner=>inner.id==item.id)){
                                    stopTags.push({...item});
                                }
                            })
                        }else if(this.isReUpload){
                            let delete_labels = this.deleteLabels||[];
                            delete_labels.forEach(item=>{
                                if(!stopTags.find(inner=>inner.id==item.id)){
                                    stopTags.push({...item});
                                }
                            })
                        }else{
                            if(this.formItem.label_type=='1'){
                                (this.taskList||[]).forEach(task=>{
                                    let delete_labels = task.delete_labels||[];
                                    delete_labels.forEach(item=>{
                                        if(!stopTags.find(inner=>inner.id==item.id)){
                                            stopTags.push({...item});
                                        }
                                    })
                                });
                            }else if(this.formItem.label_type=='2'){
                                stopTags = this.deleteLabels;
                            }
                        }

                        if(stopTags.length>0){
                            this.$confirm('标签：【'+stopTags.map(item=>item.name).join('、')+'】已被停用，请确认是否继续', '提示', {
                                confirmButtonText: '继续',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                            }).then(() => {
                                this.doSubmitData();
                            }).catch(() => {
                            });
                        }else{
                            this.doSubmitData();
                        }
                    }else{
                        console.log('error submit!!');
                        this.$message.error('表单数据不完整，请检查后重试');
                        return false;
                    }
                });
            },
            doSubmitData(){
                let reqData = {
                    project_type:this.formItem.project_type,
                    project_id:this.formItem.project_type=='1'?'':this.formItem.project_id,
                    project_name:this.formItem.project_type=='1'?'':this.formItem.project_name,
                    material_type:this.formItem.material_type,
                    app_type:this.formItem.app_type,
                    package_type:this.formItem.package_type,
                    game_classify:this.formItem.game_classify,
                    label_type:this.formItem.label_type,
                    producer_type:this.formItem.producer_type,
                };
                if(this.isOrderUpload||this.isOrderMaterialEdit){
                    // 批量上传的制作人信息
                    let batchProducerList = [];
                    for (let item in this.batchProducer) {
                        batchProducerList.push(this.batchProducer[item]);
                    }
                    reqData.producer_list = batchProducerList.map(item=>{
                        let producer = item.detail.map(inner=>{
                            if(item.distribution_method=='2'){
                                return {
                                    uid:inner.uid||inner.id,
                                    ratio:inner.ratio,
                                }
                            }else{
                                return {
                                    uid:inner.uid||inner.id,
                                }
                            }
                        });
                        return {
                            detail_id:item.detail_id,
                            distribution_method:item.distribution_method,
                            detail:producer,
                        }
                    });
                    reqData.order_id = this.orderId;
                }else{
                    if(this.formItem.producer_type=='1'){
                        reqData.producer_list = [{
                            uid:this.singleProducer,
                        }];
                        //单人制作
                    }else if(this.formItem.producer_type=='2'){
                        // 多人制作
                        reqData.distribution_method = this.formItem.distribution_method;
                        if(this.formItem.distribution_method=='1'){
                            // 平均分配
                            reqData.producer_list = this.distributionProducer.map(item=>{
                                return {
                                    uid:item,
                                }
                            });
                        }else{
                            reqData.producer_list = this.producerRatioList.map(item=>{
                                return {
                                    uid:item.id,
                                    ratio:item.ratio,
                                }
                            });
                        }
                    }
                }

                if(!this.isEdit){
                    /* 不是编辑，则需要提交 */
                    reqData.file_list = this.uploadFiles.map(item=>{
                        let copyData = cloneDeep(item);
                        if(this.formItem.label_type=='2'){
                            copyData.label_ids = this.labelIds.concat((this.deleteLabels||[]).map(item=>item.id));
                        }else{
                            copyData.label_ids = (copyData.label_ids||[]).concat((copyData.delete_labels||[]).map(item=>item.id))
                        }
                        delete copyData.delete_labels;
                        return {...copyData};
                    });
                }

                reqData.isBatch = this.isBatch;
                if(this.isBatch){
                    reqData.assign_id = Array.from(new Set(this.uploadFiles.map(item=>item.assign_id)));
                }else if(this.isOrderUpload){
                    reqData.assign_id = this.taskList[0].assign_id;
                }
                if(this.isOrderUpload){
                    reqData.order_name = this.orderInfo.order_name||'';
                }

                if(this.isEdit){
                    let fileData = this.uploadFiles[0]||{};
                    reqData.material_name = this.formItem.material_name;
                    reqData.material_id = this.materialInfo.id||this.materialInfo.material_id;
                    reqData.label_ids = (fileData.delete_labels||[]).map(item=>item.id).concat(fileData.label_ids||[]);
                    reqData.source = (this.materialInfo||{}).source||'';
                    reqData.package_type = this.formItem.package_type;
                    reqData.material_label = fileData.material_label;
                    this.submitLoading = true;
                    console.log('reqData',cloneDeep(reqData),  this.uploadFiles);
                    if(this.isOrderMaterialEdit){
                        API.editOrderMaterial({
                            material_id:reqData.material_id,
                            material_name:reqData.material_name,
                            label_ids:reqData.label_ids,
                            producer_list:reqData.producer_list,
                            package_type: this.formItem.package_type,
                            material_label:fileData.material_label,
                        }).then(res=>{
                            console.log('editMaterial',res);
                            this.submitLoading = false;
                            this.$message.success(res.info||'请求成功');
                            this.cbs.onSubmit({});
                            this.handleClose();
                        },err=>{
                            console.log('editMaterial err',err);
                            this.submitLoading = false;
                            this.$message.error(err.info||'请求异常');
                        })
                    }else if(this.isStoreMaterialEdit){
                        API.editStoreMaterial(reqData).then(res=>{
                            console.log('editMaterial',res);
                            this.submitLoading = false;
                            this.$message.success(res.info||'请求成功');
                            this.cbs.onSubmit({});
                            this.handleClose();
                        },err=>{
                            console.log('editMaterial err',err);
                            this.submitLoading = false;
                            this.$message.error(err.info||'请求异常');
                        })
                    }
                }else{
                    this.submitLoading = true;
                    if(this.isReUpload){
                        let file = this.uploadFiles[0].fileData;
                        reqData.material_name = file.name;
                        reqData.material_id = this.materialInfo.id;
                        reqData.producer_type = this.formItem.producer_type;
                        reqData.distribution_method = this.formItem.distribution_method;
                    }

                    if(this.isOrderUpload||this.isReUpload){
                        API.getWorkOrderLock({
                            assign_id:uniq(reqData.file_list.map(item=>item.assign_id)),
                        }).then(()=>{
                            this.cbs.onSubmit(reqData);
                            this.handleClose();
                        },err=>{
                            this.$message.error(err.info||'请求异常');
                            this.submitLoading = false;
                        })

                    }else{
                        this.cbs.onSubmit(reqData);
                        this.handleClose();
                    }
                }
            },
            // workOrder_v5 §1（2026-10-15 二次拍板）：「素材分类标签」默认值不再由前端切文件名，改为把文件名批量交给后端四级归类，
            //   回填「一级-二级-三级-四级」（如 原创-标准-AI）；一个字典词都没命中 → 留空（占位「名称未解析到标签」）。
            //   幂等：默认值再交给服务端归类得到的四级与直接归类文件名一致。只回填仍为空且未被用户手改的项；接口失败静默留空、不打扰上传。
            //   原 parseFileNameTag（按最后一个 "-" 切段）已退役。
            fillDefaultLabels: debounce(function () {
                if (this._isDestroyed) return;
                const pending = (this.uploadFiles || []).filter(f => f.label_pending && !f.label_loading && !f.material_label && f.fileData && f.fileData.name);
                if (!pending.length) return;
                pending.forEach(f => { this.$set(f, 'label_loading', true); });
                const names = uniq(pending.map(f => f.fileData.name));
                const apiType = (this.isStoreMaterialEdit || !this.orderId) ? 'classifyStoreFileNames' : 'classifyFileNames';
                API[apiType]({ names }).then(res => {
                    if (this._isDestroyed) return;
                    const map = {};
                    ((res && res.data) || []).forEach(r => { map[r.name] = r.label || ''; });
                    pending.forEach(f => {
                        if (!(this.uploadFiles || []).includes(f) || !f.label_pending) return;
                        if (!f.material_label && f.fileData && Object.prototype.hasOwnProperty.call(map, f.fileData.name)) {
                            this.$set(f, 'material_label', map[f.fileData.name]);
                        }
                        this.$set(f, 'label_pending', false);
                        this.$set(f, 'label_loading', false);
                    });
                }, () => {
                    // 归类失败：留空让用户手填，不弹错打断上传流程（precheck 的报错已经够多）
                    pending.forEach(f => {
                        if (!(this.uploadFiles || []).includes(f) || !f.label_pending) return;
                        this.$set(f, 'label_pending', false);
                        this.$set(f, 'label_loading', false);
                    });
                });
            }, 250),
            fileRequest(data){
                console.log('fileRequest',data);
                let _this = this;
                const reader = new FileReader();
                reader.readAsArrayBuffer(data.file);
                reader.onload = function (e) {
                    const content = e.target.result;
                    let fileMd5 = md5(content);

                    if(_this.uploadFiles.find(item=>item.md5 == fileMd5)){
                        setTimeout(()=>{
                            _this.$message.error('【'+data.file.name+'】素材重复上传，请检查');
                        });
                        data.onError();
                        return false;
                    }else if(_this.isOrderUpload){
                        let taskItem = _this.taskList.find(item=>item.assign_id == data.file.assign_id);
                        let labelList = taskItem.label||[];
                        let fileData = data.file;
                        let deleteLabels =  taskItem.delete_labels||[];


                        let fileCnt = _this.uploadedNum[taskItem.width+'*'+taskItem.height]||0;
                        console.log('upload',888,taskItem,fileCnt);
                        if(_this.isReUpload){
                            if(fileCnt>=1){
                                setTimeout(()=>{
                                    _this.$message.error('可上传数量为0，上传失败：'+data.file.name);
                                });
                                data.onError();
                                return false;
                            }
                        }else{
                            if(fileCnt>=taskItem.allow_upload_num){
                                setTimeout(()=>{
                                    _this.$message.error('可上传数量为0，上传失败：'+data.file.name);
                                });
                                data.onError();
                                return false;
                            }
                        }

                        _this.uploadFiles.push({
                            delete_labels:_this.formItem.label_type=='2'?[]:deleteLabels.map(item=>cloneDeep(item)),
                            label_ids:_this.formItem.label_type=='2'?[]:labelList.map(item=>item.id),
                            fileData:fileData,
                            md5:fileMd5,
                            assign_id:data.file.assign_id,
                            width:fileData.width,
                            height:fileData.height,
                            material_size:fileData.size,
                            material_format:fileData.material_format,
                            material_duration:fileData.material_duration,
                            isPreChecked:false,
                            material_label: '',          // 由后端归类回填（fillDefaultLabels），占位「名称未解析到标签」
                            label_pending: true,
                            label_loading: false,
                        });
                        _this.fillDefaultLabels();
                    }else{
                        _this.uploadFiles.push({
                            label_ids:[],
                            delete_labels:[],
                            fileData:data.file,
                            md5:fileMd5,
                            width:data.file.width,
                            height:data.file.height,
                            material_duration:data.file.material_duration,
                            isPreChecked:false,
                            material_label: '',
                            label_pending: true,
                            label_loading: false,
                        });
                        _this.fillDefaultLabels();
                    }

                    data.onSuccess();
                    // _this.$refs.form.validateField('file_labels');
                    _this.$refs.form.clearValidate('files');
                };
            },
            handleFileChange(file,fileList){
                console.log('handleFileChange',file,fileList);
                if(this.preCheckFiles){
                    this.preCheckFiles();
                }
            },
            async preCheckFiles(){
                if(this.preCheckLoading) return;
                if(this.uploadFiles.every(item=>item.isPreChecked)) return;
                let preItem = this.uploadFiles.find(item=>item.isPreChecked==false);
                console.log('preCheckFiles',preItem);
                if(this.uploadFiles.filter(item=>item.isPreChecked).length>100){
                    setTimeout(()=>{
                        this.$message.error('【'+preItem.fileData.name+'】添加失败，每次最多上传100个素材');
                    });
                    let index = this.uploadFiles.findIndex(item=>item.md5==preItem.md5);
                    console.log('preCheckFile err',index,preItem);
                    this.uploadFiles.splice(index, 1);

                    if(this.preCheckFiles){
                        this.preCheckFiles();
                    }
                }

                this.preCheckLoading = true;
                let apiType = 'preCheckFile';
                if(this.isStoreMaterialEdit||!this.orderId){
                    apiType = 'preCheckStoreFile';
                }
                await API[apiType]({
                    material:[{
                        md5:preItem.md5,
                        name:preItem.fileData.name,
                    }],
                },{
                    timeout:120*1000,
                    retries:5,
                }).then(()=>{
                    preItem.isPreChecked = true;
                },err=>{
                    setTimeout(()=>{
                        this.$message.error({
                            message:'<pre style="line-height: 20px;">【'+preItem.fileData.name+'】'+(err.info||"文件异常")+'</pre>',
                            dangerouslyUseHTMLString: true,
                        });
                    });
                    let index = this.uploadFiles.findIndex(item=>item.md5==preItem.md5);
                    console.log('preCheckFile err',index,preItem);
                    this.uploadFiles.splice(index, 1);
                }).finally(()=>{
                    this.preCheckLoading = false;
                    if(this.preCheckFiles){
                        this.preCheckFiles();
                    }
                })
            },
            handleUpload(file){
                let _this = this;
                let fileExt = ((file.name.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)||[])[0]||'').toLowerCase();
                if(!fileExt){
                    setTimeout(()=>{
                        this.$message.error('【'+file.name+'】添加失败，文件格式有误');
                    });
                    return false;
                }

                if(_this.formItem.material_type=='1'&&!this.formatImageExt.includes(fileExt)&&!this.orderId){
                    setTimeout(()=>{
                        this.$message.error('【'+file.name+'】添加失败，文件格式有误');
                    });
                    return false;
                }
                if(_this.formItem.material_type=='2'&&!this.formatVideoExt.includes(fileExt)&&!this.orderId){
                    setTimeout(()=>{
                        this.$message.error('【'+file.name+'】添加失败，文件格式有误');
                    });
                    return false;
                }

                if(file.name.length>300){
                    setTimeout(()=>{
                        this.$message.error('【'+file.name+'】添加失败，文件名称超过300个字符');
                    });
                    return false;
                }
                _this.uploadingFileCnt++;
                return new Promise((resolve, reject) => {
                    if(_this.uploadFiles.length>100){
                        setTimeout(()=>{
                            this.$message.error('【'+file.name+'】添加失败，每次最多上传100个素材');
                        });
                        this.uploadingFileCnt--;
                        reject();
                    }else if(file.type.includes('image')&&this.formItem.material_type=='2'){
                        setTimeout(()=>{
                            this.$message.error('【'+file.name+'】只能上传视频，请重新选择文件');
                        });
                        this.uploadingFileCnt--;
                        reject();
                    }else if(file.type.includes('video')&&this.formItem.material_type=='1'){
                        setTimeout(()=>{
                            this.$message.error('【'+file.name+'】只能上传图片，请重新选择文件');
                        });
                        this.uploadingFileCnt--;
                        reject();
                    }
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(file);
                    reader.onload = async function (e) {
                        const content = e.target.result;
                        let fileMd5 = md5(content);
                        if(!_this.uploadFiles.find(item=>item.md5 == fileMd5)){
                            if(_this.isOrderUpload){
                                // 工单上传
                                if(_this.formItem.material_type=='1'){
                                    // 图片
                                    getMediaInfo(file).then(resFile=>{
                                        console.log('getMediaInfo',resFile,file);
                                        _this.uploadingFileCnt--;

                                        if(!resFile.width||!resFile.height){
                                            setTimeout(()=>{
                                                _this.$message.error('素材不匹配：【'+file.name+'】文件格式有误');
                                            });
                                            reject();
                                            return false;
                                        }

                                        let taskItem  = _this.taskList.find(item=>{
                                            let conFormat = (item.material_format||'').toLowerCase().split(',');
                                            // file拿到的size是字节，需要把配置里的K和M转换成字节
                                            let conSize = null;
                                            let sizeUnit =(item.material_size_unit+'').toLowerCase();
                                            if(sizeUnit=='k'||sizeUnit=='kb'){
                                                conSize = (+item.material_size)*1024;
                                            }else {
                                                conSize = (+item.material_size)*1024*1024;
                                            }
                                            return conFormat.includes(fileExt.replace('.',''))&&conSize>file.size&&item.width==resFile.width&&item.height==resFile.height;
                                        });
                                        if(taskItem){
                                            if((_this.uploadedNum[taskItem.width+'*'+taskItem.height]>=taskItem.allow_upload_num)&&!_this.isReUpload){
                                                setTimeout(()=>{
                                                    _this.$message.error('该尺寸的可上传数量为0，上传失败：'+file.name);
                                                });
                                                reject();
                                            }else{
                                                file.assign_id = taskItem.assign_id;
                                                file.width = resFile.width;
                                                file.height = resFile.height;
                                                file.material_format = fileExt.replace('.','');
                                                resolve();
                                            }
                                        }else{
                                            let errTips = '';
                                            let taskList = _this.taskList||[];
                                            let widthHeightList = taskList.map(item=>item.width+'*'+item.height);
                                            let sizeList = taskList.map(item=>{
                                                let conSize = null;
                                                let sizeUnit =(item.material_size_unit+'').toLowerCase();
                                                if(sizeUnit=='k'||sizeUnit=='kb'){
                                                    conSize = (+item.material_size)*1024;
                                                }else {
                                                    conSize = (+item.material_size)*1024*1024;
                                                }
                                                return conSize;
                                            });
                                            let formatList = taskList.map(item=>item.material_format);
                                            let fileWithHeight = resFile.width+'*'+resFile.height;
                                            let format_every = formatList.every(item=>item.toLowerCase().split(',').includes(fileExt.replace('.','')))
                                            console.log(888,formatList,fileExt);
                                            if(!widthHeightList.includes(fileWithHeight)){
                                                errTips = '素材尺寸不符合';
                                            }else if(!sizeList.every(inner=>inner>file.size)){
                                                errTips = '素材大小不符合';
                                            }else if(!format_every){
                                                errTips = '素材格式不符合';
                                            }

                                            // else if(!formatList.join(',').toLowerCase().includes(fileExt.replace('.',''))){
                                            //     errTips = '素材格式不符合';
                                            // }

                                            setTimeout(()=>{
                                                _this.$message.error('素材不匹配：'+file.name+errTips);
                                            });
                                            reject();
                                        }
                                    })
                                }else{
                                    // 视频

                                    getMediaInfo(file).then(async res=>{
                                        console.log('getMediaInfo',res);
                                        _this.uploadingFileCnt--;
                                        if(!res.width||!res.height){
                                            setTimeout(()=>{
                                                _this.$message.error('素材不匹配：【'+file.name+'】文件格式有误');
                                            });
                                            reject();
                                            return false;
                                        }

                                        let resFile = res;
                                        let videoWidth = res.width;
                                        let videoHeight = res.height;
                                        let videoDuration = res.duration;
                                        let {url} = await _this.captureFrame(file);
                                        file.v_url = url;

                                        let taskItem  = _this.taskList.find(item=>{
                                            let conFormat = (item.material_format||'').toLowerCase().split(',');
                                            // file拿到的size是字节，需要把配置里的K和M转换成字节
                                            let conSize = null;
                                            let sizeUnit =(item.material_size_unit+'').toLowerCase();
                                            if(sizeUnit=='k'||sizeUnit=='kb'){
                                                conSize = (+item.material_size)*1024;
                                            }else {
                                                conSize = (+item.material_size)*1024*1024;
                                            }
                                            let conDuration = +item.material_duration;
                                            return conFormat.includes(fileExt.replace('.',''))&&conSize>file.size&&item.width==videoWidth&&item.height==videoHeight&&videoDuration<=conDuration;
                                        });

                                        if(taskItem){
                                            if((_this.uploadedNum[taskItem.width+'*'+taskItem.height]>=taskItem.allow_upload_num)&&!_this.isReUpload){
                                                setTimeout(()=>{
                                                    _this.$message.error('该尺寸的可上传数量为0，上传失败：'+file.name);
                                                });
                                                reject();
                                            }else{
                                                file.assign_id = taskItem.assign_id;
                                                file.width = videoWidth;
                                                file.height = videoHeight;
                                                file.material_duration = videoDuration;
                                                file.material_format = fileExt.replace('.','');
                                                resolve();
                                            }
                                        }else{
                                            let errTips = '';
                                            let taskList = _this.taskList||[];
                                            let widthHeightList = taskList.map(item=>item.width+'*'+item.height);
                                            let sizeList = taskList.map(item=>{
                                                let conSize = null;
                                                let sizeUnit =(item.material_size_unit+'').toLowerCase();
                                                if(sizeUnit=='k'||sizeUnit=='kb'){
                                                    conSize = (+item.material_size)*1024;
                                                }else {
                                                    conSize = (+item.material_size)*1024*1024;
                                                }
                                                return conSize;
                                            });
                                            let formatList = taskList.map(item=>item.material_format);
                                            let fileWithHeight = resFile.width+'*'+resFile.height;
                                            let durationList = taskList.map(item=>item.material_duration).filter(inner=>!!inner);
                                            let format_every = formatList.every(item=>item.toLowerCase().split(',').includes(fileExt.replace('.','')))
                                            if(!widthHeightList.includes(fileWithHeight)){
                                                errTips = '素材尺寸不符合';
                                            }else if(!sizeList.every(inner=>inner>file.size)){
                                                errTips = '素材大小不符合';
                                            }else if(!format_every){
                                                errTips = '素材格式不符合';
                                            }else if(!durationList.every(inner=>inner>videoDuration)){
                                                errTips = '素材时长不符合';
                                            }

                                            // else if(!formatList.join(',').toLowerCase().includes(fileExt.replace('.',''))){
                                            //     errTips = '素材格式不符合';
                                            // }

                                            setTimeout(()=>{
                                                _this.$message.error('素材不匹配：'+file.name+errTips);
                                            });
                                            reject();
                                        }
                                    },(err)=>{
                                        console.log('getMediaInfo err',err);
                                        reject();
                                    });
                                }
                            }else{
                                // 素材库上传
                                // 如果素材中有图片，就默认为单人制作

                                getMediaInfo(file).then(async resFile=>{
                                    console.log('getMediaInfo',resFile);
                                    _this.uploadingFileCnt--;
                                    if(!resFile.width||!resFile.height){
                                        setTimeout(()=>{
                                            _this.$message.error('素材不匹配：【'+file.name+'】文件格式有误');
                                        });
                                        reject();
                                    }

                                    file.width = resFile.width;
                                    file.height = resFile.height;
                                    file.material_duration = resFile.duration||'';

                                    if(_this.formItem.material_type=='2'){

                                        let {url} = await _this.captureFrame(file);
                                        file.v_url = url;
                                    }


                                    if(file.type.includes('image')){
                                        _this.formItem.producer_type='1';
                                    }
                                    resolve();
                                });
                            }
                        }else{
                            setTimeout(()=>{
                                _this.$message.error({
                                    message:'<pre style="line-height: 20px;">【'+file.name+'】素材重复上传，请检查</pre>',
                                    dangerouslyUseHTMLString: true,
                                });
                            });
                            _this.uploadingFileCnt--;
                            reject();
                        }
                    };
                });
            },
            handleSuccess(res){
                console.log('handleSuccess',res);
            },
            handleError(error, file, fileList){
                console.log('handleError',error, file,fileList);
            },
            handleProgress(val) {
                console.log('handleProgress',val);
            },
            beforeRemove(file){
                console.log('beforeRemove',file);
            },
            stopVideoPlay(file){
                let fileType = file.fileData.type||'';
                if(!fileType.includes('video')&&file.material_type!='2') return;
                let md5 = file.md5;
                let $video = document.querySelector('video[data-md5="'+md5+'"]');
                $video&&$video.pause();
            },
            startVideoPlay(file){
                return false;   //节省性能，不自动播放
                let fileType = file.fileData.type||'';
                if(!fileType.includes('video')) return;
                let md5 = file.md5;
                let $video = document.querySelector('.material-large-poptip video[data-md5="'+md5+'"]');
                if($video){
                    $video.play();
                }
            },
            getFilePath(file){
                if(typeof file ==='string'&&file.includes('http')){
                    return file;
                }
                return URL.createObjectURL(file);
            },
            handleRemoveFile(index){
                this.uploadFiles.splice(index, 1);
                this.$refs.form.validateField('files');
                this.$refs.form.clearValidate('label_ids');
                this.$refs.form.clearValidate('file_labels');
            },
            clearValidate(field){
                this.$refs.form.clearValidate(field);
            },
            changeLabelType(val){
                let deleteLabels = cloneDeep(this.deleteLabels);
                /*1-分别设置，2-统一设置*/
                if(val==1&&this.uploadFiles.length>0){
                    this.uploadFiles.forEach(item=>{
                        item.label_ids = this.labelIds;
                        this.$set(item,'delete_labels',deleteLabels);
                    });

                    this.$nextTick(()=>{
                        this.uploadFiles.forEach(item=>{
                            let $single = this.$refs['singleJtLabelCascader'+item.md5]||[];
                            if($single[0]&&deleteLabels.length){
                                $single[0].setDeleteLabels(deleteLabels);
                                $single[0].computePresentTags();
                            }
                        });
                    })
                }
            },
            formatFileSize(size){
                return utils.formatFileSize(size);
            },
            getMaterialDurationText(val){
                return (''+val||'').endsWith('s')?val:(val+'s');
            },
            captureFrame(videoFile, time = 0){
                let _this = this;
                return new Promise((resolve) => {
                    // 因为dom节点没有渲染到浏览器，视频播放到指定的时间就会停止播放
                    let videoElement = document.createElement('video');
                    videoElement.currentTime = time; // 设置截取的帧时间
                    // 自动播放存在兼容性问题，设置静音解决自动播放在不同浏览器的兼容性问题
                    videoElement.muted = true;
                    videoElement.autoplay = true;
                    videoElement.src = URL.createObjectURL(videoFile);
                    videoElement.oncanplay = async function () {
                        const flame = await _this.drawVideoToCanvas(videoElement);
                        videoElement = null;
                        resolve(flame);
                    };
                });
            },
            drawVideoToCanvas(video){
                return new Promise((resolve) => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    canvas.toBlob((blob) => {
                        resolve({
                            blob, // 将封面提交到服务端
                            url: URL.createObjectURL(blob), // 实现本地预览
                        });
                    });
                });
            },
        },
        beforeDestroy(){
            /* 销毁前注销preCheckFiles方法，以防preCheckFiles未请求完导致的一直调用 */
            this.uploadFiles = [];
            this.preCheckFiles = null;
        },
    }
</script>

<style lang="scss" scoped>
    .modal-wrap{
        /*max-height: 600px;*/
        max-height:calc(100vh - 200px);
        overflow-y: auto;
        overflow-x: hidden;
    }

    .material-preview-wrap video,.material-preview-wrap img{
        max-width: 100%;
        max-height: 100%;
    }
    .link-btn{
        color: #619f53;
    }


    .upload-box{
        width: 500px;
    }
    ::v-deep .upload-box .el-upload {
        width: 100%;
        .el-upload-dragger{
            padding: 10px 0;
            width: 100%;
            /*min-height: 100px;*/
            height: auto;
            .el-icon-upload{
                font-size: 40px;
                margin: 0 auto;
                line-height: 40px;
                color: #409EFF;
            }
            .el-upload__text{
                font-size: 12px;
            }
        }
    }

    .upload-box .upload-loading-wrap{
        position: absolute;
        z-index: 2;
        right: 20px;
        top: 10px;
        cursor: pointer;
        color: #409EFF;
        .el-icon-loading{
            font-size: 30px;
        }
    }


    .file-preview{
        width: 150px;
        height: 120px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        border: solid 1px #e2e2e2;
        background-color: #f8f8f9;
    }
    .file-preview img,.file-preview video{
        max-width: 100%;
        max-height: 115px;
        vertical-align: middle;
    }
    .remove-icon{
        position: absolute;
        right: -6px;
        top: -6px;
        cursor: pointer;
        z-index: 2;
        line-height: 16px;
        background-color: #fff;
        border-radius: 50%;
    }

    .material-large-poptip{
        height: 350px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .material-large-poptip img,.material-large-poptip video{
        max-height: 100%;
        max-width: 100%;
    }

    ::v-deep .select-tags-width {
        .el-cascader__search-input{
            width: 2px;
            min-width: 2px;
            margin: 2px 0 2px 2px;
            font-size: 12px;
            flex: none;
            text-indent: 4px;
        }
        .el-tag.el-tag--info{
            max-width: 52%;
        }
    }

    .user-name-label{
        display: inline-block;
        min-width: 4em;
    }

    ::v-deep .el-upload--text .is-store-upload {
        margin-top: 25px;
        margin-bottom: 25px;
    }

    .pre-file-wrap{
        display: flex;
        flex-wrap: wrap;

        .file-item{
            margin-right: 20px;
            width: 150px;
        }
    }
    .less-than{
        vertical-align: 1px;
        padding-right: 1px;
    }

    .file-info-text{
        height: 16px;
        line-height: 16px;
        background-color: rgba(0,0,0,.05);
        font-size: 12px;
        display: flex;
        justify-content: space-around;
        border: solid 1px #e2e2e2;
        border-top: none;

    }

</style>
